var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"13","height":"10","viewBox":"0 0 13 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.59 0.579956L5 7.16996L1.41 3.58996L0 4.99996L5 9.99996L13 1.99996L11.59 0.579956Z","fill":"#FF0000"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }